import { INTAKE_MESSAGE_TYPE } from '@lixionary-jira/domain';

export interface IntakeCreated {
  key: string;
  title: string;
  status: string;
}

/**
 * Tells the platform that opened the popup which ticket was created. The message goes only to the return origin
 * the integration allows, so no other page can read it. False when the popup has no opener any more.
 */
export function notifyOpener(win: Window, returnOrigin: string, ticket: IntakeCreated): boolean {
  const opener = win.opener as Window | null;
  if (!opener || opener.closed) return false;
  opener.postMessage(
    { type: INTAKE_MESSAGE_TYPE, key: ticket.key, title: ticket.title, status: ticket.status },
    returnOrigin,
  );
  return true;
}
